"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderData = void 0;
const gretchen_1 = require("gretchen");
const errors_1 = require("./errors");
__exportStar(require("./errors"), exports);
var render_data_1 = require("./render-data");
Object.defineProperty(exports, "RenderData", { enumerable: true, get: function () { return __importDefault(render_data_1).default; } });
class ApiClient {
    constructor(defaultOpts) {
        const defaultHeaders = {};
        if (defaultOpts === null || defaultOpts === void 0 ? void 0 : defaultOpts.headers) {
            Object.keys(defaultOpts.headers).forEach(key => {
                defaultHeaders[key.toLowerCase()] = defaultOpts.headers[key];
            });
        }
        this.defaultOpts = Object.assign(Object.assign({}, defaultOpts), { headers: Object.assign({ accept: 'application/json', 'content-type': 'application/json' }, defaultHeaders) });
    }
    static formatBody(body) {
        try {
            return JSON.stringify(body);
        }
        catch (error) {
            throw new errors_1.ClientError('Failed to parse request body', error instanceof Error ? error : undefined);
        }
    }
    get(url, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(url, Object.assign(Object.assign({}, opts), { method: 'GET' }));
        });
    }
    post(url, body, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(url, Object.assign(Object.assign({}, opts), { method: 'POST', body: body !== undefined ? ApiClient.formatBody(body) : undefined }));
        });
    }
    put(url, body, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(url, Object.assign(Object.assign({}, opts), { method: 'PUT', body: body !== undefined ? ApiClient.formatBody(body) : undefined }));
        });
    }
    patch(url, body, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(url, Object.assign(Object.assign({}, opts), { method: 'PATCH', body: body !== undefined ? ApiClient.formatBody(body) : undefined }));
        });
    }
    delete(url, body, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(url, Object.assign(Object.assign({}, opts), { method: 'DELETE', body: body !== undefined ? ApiClient.formatBody(body) : undefined }));
        });
    }
    fetch(url, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { response: res } = yield (0, gretchen_1.gretch)(url, Object.assign(Object.assign({}, this.defaultOpts), opts)).flush();
            const payloadText = yield res.text();
            const payload = (payloadText.length ? JSON.parse(payloadText) : null);
            if (!res.ok) {
                throw errors_1.SentinelError.parse(payload, res.status);
            }
            return {
                ok: res.ok,
                status: res.status,
                redirected: res.redirected,
                url: res.url,
                type: res.type,
                headers: res.headers,
                payload,
            };
        });
    }
}
exports.default = ApiClient;
//# sourceMappingURL=index.js.map